<template>
  <v-app>
    <router-view />
  </v-app>
</template>

<script setup>
  import { useTheme } from 'vuetify';

  const theme = useTheme();
  theme.global.name.value = 'edReportsTheme';
</script>
